
export default function getUrlProductUtil (handle, variantId) {
  return `/products/${handle}?variant=${variantId}`
}
